// extracted by mini-css-extract-plugin
module.exports = {"internalHtmlInput":"InternalHtmlWindowComponent_internalHtmlInput__3wIg0"};